import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react';
import { Icono } from './Icono';

interface Aviso {
  id: number;
  tipo: 'exito' | 'error';
  texto: string;
}

const Contexto = createContext<(texto: string, tipo?: Aviso['tipo']) => void>(() => undefined);

/** Confirmaciones que no interrumpen: aparecen, se leen y se van solas. */
export function ProveedorAvisos({ children }: { children: ReactNode }) {
  const [avisos, setAvisos] = useState<Aviso[]>([]);
  const avisar = useCallback((texto: string, tipo: Aviso['tipo'] = 'exito') => {
    const id = Date.now() + Math.random();
    setAvisos((lista) => [...lista.slice(-3), { id, tipo, texto }]);
    setTimeout(() => setAvisos((lista) => lista.filter((a) => a.id !== id)), tipo === 'error' ? 7000 : 3500);
  }, []);
  const valor = useMemo(() => avisar, [avisar]);
  return (
    <Contexto.Provider value={valor}>
      {children}
      <div className="avisos" role="status" aria-live="polite">
        {avisos.map((aviso) => (
          <div key={aviso.id} className={`aviso aviso--${aviso.tipo}`}>
            <Icono nombre={aviso.tipo === 'exito' ? 'check' : 'alerta'} />
            <span>{aviso.texto}</span>
          </div>
        ))}
      </div>
    </Contexto.Provider>
  );
}

export function useAvisar() {
  return useContext(Contexto);
}
